module.exports = __webpack_public_path__ + "zvetseni-prsou_14_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_14_before.jpg
// module id = 1302
// module chunks = 0